export default {
  action: {
    cancelled: 'Anulowany',
    completed: 'Zakończony',
    new: 'Nowy',
    sent: 'Wysłany',
    unfinishedForm: 'Nieukończony formularz'
  },
  activationAccount: {
    activeAccountButton: 'Aktywuj konto',
    confirmationActivation: 'Potwierdzenie aktywacji konta',
    thankYouForActivation: 'Dziękujemy za potwierdzenie rejestracji. Po zatwierdzeniu przez Administratora otrzymasz wiadomość e-mail. Wówczas możesz zacząć korzystać z panelu eksperta.'
  },
  adviserSettings: {
    contactData: 'Dane kontaktowe',
    education: 'Wykształcenie',
    invoiceData: 'Dane do faktury',
    logoAndColors: 'Kolorystyka i logo',
    myExpertCard: 'Moja wizytówka eksperta',
    photoExpert: 'Zdjęcie profilowe eksperta ',
    workExperience: 'Doświadczenie zawodowe',
    yourDataHasBeenSaved: 'Twoje dane zostały zapisane',
    yourDataModifyError: 'Modyfikacja Twoich danych nie powiodła się. Spróbuj ponownie.'
  },
  adviserSettingsBusinessCardInfo: {
    cut: 'Przytnij',
    dateStartWork: 'Data rozpoczęcia pracy',
    deletePhoto: 'Usuń zdjęcie',
    description: 'Opis',
    infoAboutYourCustomerCardHasBeenSaved: 'Informacje o Twojej wizytówce klienta zostały zapisane',
    itsNotAPhoto: 'Wybrany plik nie jest plikiem graficznym',
    littleDescription: 'Krótki opis',
    photo: 'Zdjęcie',
    preview: 'Podgląd',
    reset: 'Resetuj',
    thisTextWillBeVisibleOnYourCard: 'Ten tekst będzie widoczny w Twojej wizytówce, w części "O mnie".',
    thisTextWillBeVisibleUnderYourSurname: 'Ten tekst będzie widoczny na liście ekspertów, pod Twoim nazwiskiem.',
    yourDataWillBePublic: 'Informacje podane w tej części będą dostępne publicznie.'
  },
  adviserSettingsEducationInfo: {
    addEntry: 'Dodaj wpis',
    areYouSureRemove: 'Czy na pewno chcesz usunąć ten wpis?',
    editEntry: 'Edycja wpisu',
    entryHasBeenRemove: 'Wybrany wpis został usunięty',
    entryModifyError: 'Modyfikacja wpisu nie powiodła się. Spróbuj ponownie.',
    entryRemove: 'Usunięto wpis',
    entryRemoveError: 'Usuwanie wpisu nie powiodło się. Spróbuj ponownie.',
    fieldOfStudy: 'Kierunek studiów',
    newEntry: 'Nowy wpis',
    savedEntry: 'Zapisano wpis',
    selectedEntryHasBeenSaved: 'Wybrany wpis został zapisany',
    timeEnd: 'Data zakończenia',
    timeStart: 'Data rozpoczęcia',
    university: 'Uczelnia'
  },
  adviserSettingsEmailInfo: {
    currentColor: 'Aktualny kolor',
    generalColor: 'Kolor główny',
    logo: 'Logo',
    selectNewColor: 'Wybierz nowy kolor',
    sendTestMailMessage: 'Testowa wiadomość e-mail została wysłana',
    sendTestMailMessageError: 'Wysyłanie testowej wiadomości e-mail nie powiodło się. Spróbuj ponownie.'
  },
  adviserSettingsExperienceInfo: {
    employer: 'Pracodawca',
    position: 'Stanowisko'
  },
  adviserSettingsInvoiceInfo: {
    yourDataForInvoicesHasBeenSaved: 'Twoje dane do faktury zostały zapisane'
  },
  advisersFinder: {
    collapseFilters: 'Zwiń filtry',
    errorLocation: 'Nie udało się pobrać Twojej lokalizacji. Sprawdź ustawienia przeglądarki/urządzenia i spróbuj ponownie.',
    expandFilters: 'Rozwiń filtry',
    findFinanceExpert: 'Znajdź eksperta finansowego, który doradzi Ci w wyborze najlepszej oferty kredytowej.',
    fromTheHighestRated: 'Od najwyżej ocenianych',
    fromTheMostFrequentlyRated: 'Od najczęściej ocenianych',
    inDistanceFromMe: 'W odległości ode mnie',
    noItemForShow: 'Brak elementów do wyświetlenia',
    onSurName: 'Po nazwisku',
    resetFilters: 'Resetuj filtry',
    showOnlyOnlineExperts: 'Pokaż tylko ekspertów online',
    sort: 'Sortuj',
    theFinanceExpert: 'Eksperci finansowi'
  },
  app: {
    designDevelopment: 'Projekt i wykonanie',
    restartSessionError: 'Nastąpił błąd podczas odnawiania sesji. Proszę odświeżyć stronę.'
  },
  articleForm: {
    adminComment: 'Komentarz administratora',
    article: 'Artykuł',
    articles: 'Artykuły',
    articleSaveAndSend: 'Twój artykuł został zapisany i wysłany do akceptacji',
    backToArticleList: 'Wróć do listy artykułów',
    saveArticle: 'Zapisano artykuł',
    saveArticleError: 'Zapis artykułu nie powiódł się. Spróbuj ponownie.'
  },
  articleList: {
    createArticle: 'Stwórz artykuł',
    deleteArticle: 'Usunięto artykuł',
    deleteArticleError: 'Usuwanie artykułu nie powiodło się. Spróbuj ponownie.',
    deleteSelectArticle: 'Wybrany artykuł został usunięty',
    doYouWantDeleteArticle: 'Czy na pewno chcesz usunąć ten artykuł?',
    linkToArticle: 'Link do artykułu',
    published: 'Opublikowany'
  },
  calendar: {
    addMeetings: 'Dodaj spotkanie',
    allSayEvent: 'Wydarzenie całodniowe',
    areYouSureToRemoveMeeting: 'Czy na pewno chcesz usunąć to spotkanie?',
    commencement: 'Rozpoczęcie',
    completion: 'Zakończenie',
    deletedMeeting: 'Usunięto spotkanie',
    editMeeting: 'Edytuj spotkania',
    endTime: 'Godzina zakończenia',
    meeting: 'spotkanie | spotkania | spotkań',
    meetingModifyError: 'Modyfikacja spotkania nie powiodła się. Spróbuj ponownie.',
    meetingsOn: 'Spotkania w dniu',
    planMeeting: 'Planuj spotkanie',
    removeMeetingError: 'Usuwanie spotkania nie powiodło się. Spróbuj ponownie.',
    savedMeeting: 'Zapisano spotkanie',
    selectedMeetingHasBeenRemove: 'Wybrane spotkanie zostało usunięte',
    selectedMeetingWasRecorded: 'Wybrane spotkanie zostało zapisane',
    showToday: 'Pokaż dzisiaj',
    startTime: 'Godzina rozpoczęcia'
  },
  client: {
    addClient: 'Dodaj klienta',
    client: 'Klient',
    clientAvatar: 'Avatar klienta',
    clients: 'Klienci',
    fullClientsList: 'Pełna lista klientów'
  },
  communication: {
    messageEmail: 'Wiadomości e-mail',
    messageSMS: 'Wiadomości SMS'
  },
  communicationMail: {
    emailSend: {
      emailHasBeenSend: 'Wiadomość e-mail została wysłana',
      emailSendError: 'Wysyłanie wiadomości e-mail nie powiodło się. Spróbuj ponownie.',
      emailSendSuccess: 'Wysłano wiadomość e-mail'
    },
    selectRecipients: 'Wybierz odbiorców',
    sendEmailToCustomer: 'Wiadomość e-mail została wysłana do klientów.',
    sendTestMail: 'Wyślij testowy e-mail',
    subject: 'Temat'
  },
  communicationSms: {
    customersChoose: {
      choose: 'Wybrano',
      customers: 'klientów'
    },
    deselectAll: 'Odznacz wszystkich',
    messageSend: 'Wyślij wiadomość',
    messageSendTo: {
      messageSendToCustomer: 'Wiadomość SMS została wysłana do klientów.',
      messageSendToCustomerError: 'Wysyłanie wiadomości nie powiodło się. Spróbuj ponownie.'
    },
    messageSmsSendTo: {
      messageSmsSendToCustomer: 'Wysłano wiadomość SMS',
      messageSmsSendToCustomerError: 'Wysyłanie wiadomości SMS nie powiodło się. Spróbuj ponownie.',
      messageSuccessSend: 'Wiadomość SMS została wysłana'
    },
    recipients: 'Odbiorcy',
    sendForAll: 'Wyślij do wszystkich',
    sendTestSms: 'Wyślij testowy SMS',
    sendTestSmsText: 'Wiadomość<span class="hidden-mobile-tiny">, którą chcesz wysłać</span>'
  },
  credit: {
    bankEmployee: 'Pracownik banku',
    creditAdvisor: 'Doradca kredytowy',
    creditExpert: 'Ekspert kredytowy',
    insuranceAgent: 'Agent ubezpieczeniowy'
  },
  customer: {
    backToCustomerList: 'Wróć do listy klientów',
    customerAccountNotActive: 'Konto klienta nie jest aktywne. Do klientów nieaktywnych nie mona wysyłać wiadomości.',
    customerCreditOffers: 'Oferty kredytowe',
    customerNumber: 'Numer klienta',
    incorrectStatus: 'Niepoprawny status',
    sendInvitation: 'Wyślij zaproszenie'
  },
  customerAgreementsForm: {
    consent: {
      accept: 'Akceptuję',
      and: 'oraz',
      contactWithExpert: 'Zgoda na kontakt ekspertów',
      marketing: 'Zgoda marketingowa',
      privacyPolicy: 'politykę prywatności',
      privacyPolicyTitle: 'Polityka Prywatności',
      terms: 'regulamin',
      termsAndPrivacy: 'Zgoda na warunki regulaminu oraz polityki prywatności',
      termsTitle: 'Regulamin'
    },
    informationSendEmail: {
      offers: 'Chcę otrzymywać mailowo informacje o ofertach, promocjach, usługach lub produktach finansowych bezpośrednio od ekspertów, których wizytówki dostępne są w serwisie',
      serwis: 'Chcę otrzymywać mailowo informacje związane z możliwościami, jakie oferuje serwis'
    },
    marketingConsentCustomers: 'Zgody marketingowe klienta',
    updateProfileError: 'Aktualizacja danych nie powiodła się. Spróbuj ponownie.',
    yourProfileHasBeenUpdate: 'Twój profil został zaktualizowany'
  },
  customerForm: {
    customerAdded: 'Dodano klienta',
    customerData: 'Dane klienta',
    myData: 'Moje dane',
    newCustomerAdded: 'Nowy klient został zapisany',
    newCustomerAddedError: 'Dodawanie nowego klienta nie powiodło się. Spróbuj ponownie.'
  },
  customerFormWrapper: {
    addNewCustomer: 'Dodaj nowego klienta',
    editCustomer: 'Edycja klienta'
  },
  customerSettings: {
    deleteCustomer: 'Usuń klienta',
    marketingConsents: 'Zgody marketingowe'
  },
  customersList: {
    areYouSureSendAnInvitation: 'Czy na pewno chcesz wysłać zaproszenie?',
    deleteAccountCustomer: 'Usunięto konto klienta',
    deleteAccountCustomerError: 'Usuwanie konta klienta nie powiodło się. Spróbuj ponownie.',
    deleteAccountCustomersError: 'Usuwanie klientów nie powiodło się. Spróbuj ponownie.',
    deletedCustomers: 'Usunięto klientów',
    deleteSelectAccountCustomer: 'Wybrane konto klienta zostało usunięte',
    deleteSelectCustomers: 'Usuń zaznaczonych klientów',
    doYouWantDeleteAccountCustomer: 'Czy na pewno chcesz usunąć konto tego klienta?',
    doYouWantDeleteAccountCustomers: 'Czy na pewno chcesz usunąć wybranych klientów?',
    invitationSentToCustomer: 'Zaproszenie zostało wysłane do klienta.',
    inviteCustomer: 'Zaproszono klienta',
    lastInteraction: 'Ostatnia interakcja',
    lastLogin: 'Ostatnie logowanie',
    selectedCustomersHaveBeenRemoved: 'Wybrani klienci zostali usunięci',
    sendInvitationError: 'Wysyłanie zaproszenia do klienta nie powiodło się. Spróbuj ponownie.'
  },
  customerStatuses: {
    draft: 'Szkic',
    invitationConfirmed: 'Zaproszenie potwierdzone',
    invited: 'Zaproszony'
  },
  dashboard: {
    acceptedClients: 'Zaakceptowani klienci',
    activeCreditsOffers: 'Aktywne oferty kredytowe',
    allCustomers: 'Wszyscy klienci',
    cancelledOffers: 'Anulowane oferty',
    checkTheProfile: 'Sprawdź profil',
    completedOffers: 'Zakończone oferty',
    cookieSettings: 'Ustawienia cookies',
    createOffer: 'Stwórz ofertę',
    createQuestion: 'Stwórz zapytanie',
    creditsOffers: 'Oferty<span class="hidden-mobile-small"> kredytowe</span>',
    currentCustomersServed: 'Aktualnie obsługiwani klienci',
    customersAcquired: 'pozyskanych klientów',
    fullOffersList: 'Pełna lista ofert',
    inviteClients: 'Zaproszeni klienci',
    lastSevenDays: 'Ostatnie 7 dni',
    lastThirtyDays: 'Ostatnie 30 dni',
    myMessage: 'Moje wiadomości',
    myOffers: 'Moje oferty',
    mySettings: 'Moje ustawienia',
    newOffer: 'Nowa oferta',
    newOffers: 'Nowe oferty',
    offeringsRequiringInteraction: 'Oferty wymagające interakcji',
    orderConsultation: 'Zamów konsultacje',
    pendingTasksCreditsOffers: 'Oczekujące zadania - Oferty kredytowe',
    pendingTasksCustomer: 'Oczekujące zadania - Klienci',
    requiredInteractions: 'Wymagane interakcje',
    sendOffers: 'wysłane oferty',
    uncompletedOffers: 'Nieukończone oferty',
    waitingMessage: 'Oczekujące wiadomości',
    waitOffers: 'Czeka na ofertę',
    welcomeToPanel: 'Witaj w panelu klienta!'
  },
  daysOfWeek: {
    friday: 'piątek',
    fridayShort: 'pt.',
    monday: 'poniedziałek',
    mondayShort: 'pn.',
    saturday: 'sobota',
    saturdayShort: 'sb.',
    sunday: 'niedziela',
    sundayShort: 'nd.',
    thursday: 'czwartek',
    thursdayShort: 'czw.',
    tuesday: 'wtorek',
    tuesdayShort: 'wt.',
    wednesday: 'środa',
    wednesdayShort: 'śr.'
  },
  forgotPassword: {
    errorAuth: 'Błąd autoryzacji. Spróbuj ponownie',
    recoverPassword: 'Odzyskaj hasło',
    resetPassword: 'Zresetuj hasło'
  },
  general: {
    finhub: 'FinHub',
    finhubLogo: 'logo FinHub',
    finPl: 'FinPl',
    finPlLogo: 'logo FinPl'
  },
  inquiriesList: {
    afterModificationDate: 'Po dacie modyfikacji',
    areYouSureDeleteOffer: 'Czy na pewno chcesz usunąć tę ofertę?',
    areYouSureDeleteOffers: 'Czy na pewno chcesz usunąć wybrane oferty?',
    created: 'Utworzono',
    deleteOffer: 'Usunięto ofertę',
    deleteOfferError: 'Usuwanie oferty nie powiodło się. Spróbuj ponownie.',
    deleteOffers: 'Usunięto oferty',
    deleteOffersError: 'Usuwanie ofert nie powiodło się. Spróbuj ponownie.',
    deleteSelectOffers: 'Usuń zaznaczone oferty',
    fillingOutTheForm: 'Wypełnienie formularza',
    lastContact: 'Ostatni kontakt',
    selectOfferDelete: 'Wybrana oferta została usunięta',
    selectOffersDelete: 'Wybrane oferty zostały usunięte'
  },
  inquiry: {
    addingCreditOffer: 'Dodawanie oferty kredytowej',
    assignedCustomer: 'Przypisany klient',
    assignedTo: 'przypisana do',
    backToOffersList: 'Wróć do listy ofert',
    complaints: 'Reklamacje',
    creditOffer: 'Oferta kredytowa',
    deleteOffer: 'Usuń ofertę',
    deleteQuestion: 'Usuń zapytanie',
    duplicateOffer: 'Duplikuj ofertę',
    duplicateQuestion: 'Duplikuj zapytanie',
    editOffer: 'Edytuj ofertę',
    editQuestion: 'Edytuj zapytanie',
    formOffer: 'Formularz oferty',
    giveARating: 'Wystaw ocenę',
    inquiryForCounter: '1 ofertę | {n} oferty | {n} ofert',
    inquiryImage: 'Grafika oferty',
    newCreditOffer: 'Nowa oferta kredytowa',
    newQuestionOffer: 'Nowe zapytanie ofertowe',
    offerQuestion: 'Zapytanie ofertowe',
    opinion: 'Opinie',
    saveOffer: 'Zapisz ofertę',
    saveQuestion: 'Zapisz zapytanie',
    theFormCompletedBy: 'Formularz wypełniony przez',
    titleMobile: 'Oferta'
  },
  inquiryAssignedCustomer: {
    deleteChoose: 'Usuń wybór',
    searchCustomer: 'Szukaj klienta',
    selectedAccountCustomerNoExits: 'Konto wybranego klienta już nie istnieje. Zalecamy usunięcie oferty.<br> Możesz zduplikować tę ofertę i przypisać do niej innego klienta.',
    selectedCustomer: 'Wybrany klient',
    selectExistingProfile: 'Wybierz istniejący profil',
    youCantChangeStatusOffer: 'Uwaga! Nie można zmienić statusu oferty i wysyłać wiadomości, dopóki klient nie zatwierdzi zaproszenia.'
  },
  inquiryBankOffer: {
    allBanksOnList: 'Chcę poznać najlepsze oferty z&nbsp;pośród wszystkich banków, z&nbsp;którymi współpracuje FinHub.',
    doYouWantNowOffersBanks: 'Czy chcesz poznać oferty konkretnych banków?',
    onlyMyOwnChoose: 'Chcę poznać najlepsze oferty tylko banków, które sam wybiorę.',
    preferredBanksOffer: 'Preferowana oferta banków',
    selectAll: 'Zaznacz wszystkie',
    selectedBanks: 'Wybrane banki'
  },
  inquiryComplaints: {
    areYouSureYouWantToArchiveClaim: 'Czy na pewno chcesz zarchiwizować reklamację?',
    complaintArchived: 'Reklamacja zarchiwizowana',
    complaintArchivedError: 'Archiwizacja reklamacji nie powiodła się. Spróbuj ponownie.',
    complaintHasBeenArchived: 'Wiadomości w wątku reklamacji zostały zarchiwizowane',
    complaintProcess: 'Jeśli Twoja współpraca z ekspertem nie ułożyła się, możesz rozpocząć proces reklamacyjny. Kliknij przycisk niżej aby otworzyć czat z administratorem serwisu',
    makeComplaint: 'Zgłaszam reklamację',
    sendComplaint: 'Wysłano zgłoszenie reklamacji',
    sendComplaintError: 'Wysłanie wiadomości nie powiodło się. Spróbuj ponownie.',
    yourComplaint: 'Twoja reklamacja',
    yourComplaintHasBeenSend: 'Wiadomość w wątku reklamacji została wysłana'
  },
  inquiryContactInfo: {
    chooseHours: 'Wybierz godzinę',
    contactInformation: 'Informacje kontaktowe',
    preferredContactHours: 'Preferowane godziny kontaktu'
  },
  inquiryFiles: {
    areYouSureSelectedFileRemove: 'Czy na pewno chcesz usunąć wybrany plik?',
    downloadFileError: 'Wystąpił błąd podczas pobierania pliku',
    filesAttached: 'Załączono pliki',
    filesAttachedError: 'Załączanie plików nie powiodło się. Spróbuj ponownie.',
    filesHasBeenAttached: 'Pliki zostały załączony do oferty',
    filesHasBeenUpdated: 'Wybrany plik został zaktualizowany',
    filesUpdated: 'Plik zaktualizowany',
    filesUpdatedError: 'Aktualizacja pliku nie powiodła się. Spróbuj ponownie.',
    noFileForOffer: 'Brak plików załączonych do oferty',
    removeFile: 'Usunięto plik',
    removeFileError: 'Usuwanie pliku nie powiodło się. Spróbuj ponownie.',
    selectedFileRemove: 'Wybrany plik został usunięty',
    youCanAddFileAfterSave: 'Pliki mogą być dodawane po zapisaniu oferty.'
  },
  inquiryFinancialInfo: {
    addFinancialCommitment: 'Dodaj zobowiązanie finansowe',
    addSourceIncome: 'Dodaj źródło dochodu',
    addSourceOfIncome: 'Dodaj źródło dochodu',
    amountOfIncome: 'Wysokość dochodu',
    amountOfIncomeCurrentYear: 'Wysokość dochodu za rok obecny',
    amountOfIncomePreviousYear: 'Wysokość dochodu za rok poprzedni',
    amountOfRevenueCurrentYear: 'Wysokość przychodu za rok obecny',
    amountOfRevenuePreviousYear: 'Wysokość przychodu za rok poprzedni',
    areYouSureYouWantToRemoveCommitment: 'Czy na pewno chcesz usunąć to zobowiązanie?',
    areYouSureYouWantToRemoveSourceIncome: 'Czy na pewno chcesz usunąć to źródło dochodu?',
    bankSalaryReceived: 'Bank, do którego wpływa wynagrodzenie',
    commitmentHasBeenRemove: 'Zobowiązanie zostało usunięte',
    contractType: 'Rodzaj umowy',
    currencyOfIncome: 'Waluta dochodu',
    deleteCommitment: 'Usuń zobowiązanie',
    DoYouHaveSourcesOfIncome: 'Czy posiadasz źródła dochodu',
    editCommitment: 'Edytuj zobowiązanie',
    editSourceIncome: 'Edycja źródła dochodu',
    financialData: 'Dane finansowe',
    financialLiabilities: 'Zobowiązania finansowe',
    firstAddFinancialCommitment: 'Najpierw dodaj źródło dochodu',
    formOfContact: 'Forma umowy',
    forRepayment: 'Do spłaty',
    income: 'Dochód',
    incomeThisYear: 'Dochód w tym roku',
    industry: 'Branża',
    installmentAmount: 'Wysokość raty',
    nameOfCurrency: 'Nazwa waluty',
    nameTypeOfIncome: 'Nazwa rodzaju dochodu',
    numberBillingMonthsCurrentYear: 'Liczba miesięcy rozliczeniowych w bieżącym roku',
    offerMustBeRecorded: 'Należy zapisać ofertę aby trwale wprowadzić tę zmianę',
    revenueThisYear: 'Przychód w tym roku',
    settlementMethod: 'Sposób rozliczenia',
    sourceIncomeHasBeenRemove: 'Źródło dochodu zostało usunięte',
    taxRate: 'Stawka podatku',
    typeOfIncome: 'Rodzaj dochodu',
    youCanAddOnlyToSourceIncome: 'Zobowiązania finansowe można dodawać tylko do źródeł dochodu będących działalnością gospodarczą'
  },
  inquiryForm: {
    basicInfo: 'Podstawowe informacje',
    chooseTheCustomer: 'Przed przystąpieniem do edycji formularza oferty należy wybrać klienta.',
    formSaved: 'Zapisano formularz',
    householdInfo: 'Gospodarstwo domowe',
    modifyFormError: 'Modyfikacja formularza nie powiodła się. Spróbuj ponownie.',
    modifyOfferError: 'Modyfikacja oferty nie powiodła się. Spróbuj ponownie.',
    offerHasBeenSave: 'Wybrana oferta została zapisana',
    queryHasBeenSaved: 'Wybrane zapytanie zostało zapisane',
    queryModifyError: 'Modyfikacja zapytania nie powiodła się. Spróbuj ponownie.',
    querySaved: 'Zapisano zapytanie',
    saveOffer: 'Zapisano ofertę',
    thankYouForFillingForm: 'Dziękujemy za wypełnienie formularza. Obecnie szukamy dla Ciebie najlepszego eksperta.'
  },
  inquiryHouseholdInfo: {
    additionalInfo: 'Dodatkowe informacje',
    ageOfOldestBorrower: 'Wiek najstarszego kredytobiorcy',
    numberOfPeopleOnHousehold: 'Liczba osób w gospodarstwie domowym'
  },
  inquiryLiabilitiesInfo: {
    addCommitment: 'Dodaj zobowiązanie',
    amountRepaid: 'Kwota do spłaty',
    currencyAmountRepaid: 'Waluta kwoty do spłaty',
    currencyOfCommitment: 'Waluta zobowiązania',
    doYouHaveFinancialLiabilities: 'Czy posiadasz zobowiązania finansowe',
    editCommitment: 'Edycja zobowiązania',
    nameOfCurrencyAmountRepaid: 'Nazwa waluty kwoty do spłaty',
    nameOfCurrencyOfCommitment: 'Nazwa waluty zobowiązania',
    newCommitment: 'Nowe zobowiązanie',
    sendOpinion: 'Wysłano opinię',
    sendOpinionError: 'Wysłanie opinii nie powiodła się. Spróbuj ponownie.',
    sourceIncome: 'Źródło dochodu',
    typeOfCommitment: 'Rodzaj zobowiązania',
    yourExpertAssessment: 'Twoja ocena eksperta',
    yourOpinionWasSend: 'Twoja opinia została wysłana.<br>Dziękujemy!'
  },
  inquiryOfferForm: {
    backToComparingOffer: 'Wróć<span class="hidden-mobile-tiny"> do porównania ofert</span>',
    bridgeInsurance: 'Ubezp. pomostowe',
    commission: 'Prowizja',
    earlyRepayment: 'Wcz. spłata',
    estatesInsurance: 'Ubezp. nieruchomości',
    formOfferForCustomer: 'Formularz oferty dla klienta',
    interestRate: 'Oproc.',
    interestRateFixed: 'Oproc. stałe',
    lifeInsurance: 'Ubezp. życie',
    margin: 'Marża',
    noSelectedBankForOffer: 'Nie wybrano banków do oferty',
    offerEdit: 'Edycja oferty',
    offerHaveVariant: 'Oferta posiada warianty',
    offerSaveError: 'Zapis label oferty nie powiódł się.',
    pricing: 'Wycena',
    recalculate: 'Przelicz',
    selectCustomer: 'Wybór klienta',
    selectOfferForCustomer: 'Wybierz ofertę i warianty dla klienta',
    wibor: 'WIBOR',
    workInsurance: 'Ubezp. pracy'
  },
  inquiryOfferLoanSimulation: {
    capital: 'Kapitał',
    creditAmount: 'Kwota kredytu',
    creditCondition: 'Stan kredytu',
    creditTermsAndConditions: 'Warunki kredytu',
    installmentPlan: 'Plan ratalny',
    interest: 'Odsetki',
    methodOfRepayment: 'Sposób spłaty',
    monthInstallment: 'Miesięczna rata',
    numberInstallment: 'Nr raty',
    numberOfInstallments: 'Liczba rat',
    rateInterest: 'Oprocentowanie',
    ratesInstallmentsSimulation: 'Symulacja rat oferty przy oprocentowaniu',
    repaymentPeriod: 'Okres spłaty'
  },
  inquiryOffers: {
    addOffer: 'Dodaj ofertę',
    addTheFirstOffer: 'Nie przygotowałeś jeszcze żadnej oferty. Dodaj pierwszą ofertę.',
    areYouSureToSendMessage: 'Czy na pewno chcesz wysłać powiadomienie?',
    bridgingInsurance: 'Ubezpieczenie pomostowe',
    earlyOverpaymentValue: 'Wcześniejsza nadpłata',
    earlyRepaymentValue: 'Wcześniejsza spłata',
    finishing: 'Wykończenie',
    fixedLendingRate: 'Oprocentowanie stałe',
    fixedLoanInstallment: 'Rata oprocentowanie stałe',
    lendingRateValue: 'Oprocentowanie zmienne',
    lifeInsuranceValue: 'Ubezpieczenie na życie',
    loanInstallmentValue: 'Rata oprocentowanie zmienne',
    messageSendError: 'Wysyłanie wiadomości nie powiodło się. Spróbuj ponownie.',
    messageSendSuccess: 'Wiadomość została wysłana',
    messageSendSuccessAboutOffers: 'Do klienta została wysłana wiadomość o przygotowanych ofertach,',
    noOffersHaveYet: 'Nie przygotowano jeszcze żadnych ofert.',
    notifyCustomerAboutOffer: 'Powiadom klienta o ofercie',
    ownContribution: 'Wkład własny',
    propertyInsuranceValue: 'Ubezpieczenie nieruchomości',
    propertyPrice: 'Cena nieruchomości',
    sendMessageChangeStatus: 'Wysłanie powiadomienia spowoduje zmianę statusu oferty na "Wysłany"',
    simulationInstallmentFixed: 'Symulacja rat - oproc. stałe',
    simulationInstallmentVariable: 'Symulacja rat - oproc. zmienne',
    valuation: 'Wycena nieruchomości',
    workInsuranceValue: 'Ubezpieczenie od utraty pracy'
  },
  inquiryOffersCart: {
    offerNotYetAdded: 'Nie dodano jeszcze oferty',
    offerVariant: 'wariant oferty',
    selectedOffers: 'Wybrane oferty'
  },
  inquirySingleOffer: {
    addedToOffer: 'Dodany do oferty',
    addToOffer: 'Dodaj<span class="hidden-mobile">  do oferty</span>',
    cannotBeCombinedWithSelectedOffer: 'nie można łączyć z wybraną ofertą',
    deleteFromOffer: 'Usuń<span class="hidden-mobile"> z oferty</span>',
    excluded: 'Wykluczony',
    hideDetailsOffer: 'Ukryj detale<span class="hidden-mobile"> oferty</span>',
    showDetailsOffer: 'Pokaż detale<span class="hidden-mobile"> oferty</span>'
  },
  inquiryStatusSelect: {
    areYouSureYouWantToChangeTheStatusOfTheOffer: 'Czy na pewno chcesz zmienić status oferty?',
    modifyStatusError: 'Modyfikacja statusu nie powiodła się. Spróbuj ponownie.',
    orderStatus: 'Status zamówienia',
    savedStatus: 'Zapisano status',
    StatusHasBeenSaved: 'Wybrany status został zapisany'
  },
  inquiryTransactionType: {
    amountForFinishing: 'Kwota na wykończenie',
    doYouNeedFundsForFinishing: 'Czy potrzebujesz środków na wykończenie',
    expectedLoanInstallment: 'Oczekiwana rata kredytu',
    metric: 'Metraż',
    purposeOfCredit: 'Cel kredytu',
    subjectOfSecurity: 'Przedmiot zabezpieczenia',
    valueOfProperty: 'Wartość nieruchomości',
    yourOwnContribution: 'Twój wkład własny będzie wynosił'
  },
  installmentTypes: {
    diminish: 'Raty malejące',
    equal: 'Raty stałe'
  },
  invitationConfirm: {
    confirmInvite: 'Potwierdź zaproszenie',
    invitationAccept: 'Zaproszenie zostało potwierdzone.',
    invitationConfirmation: 'Potwierdzenie zaproszenia'
  },
  list: {
    fromLatest: 'Od najnowszych',
    fromOldest: 'Od najstarszych',
    lastModify: 'Ostatnia modyfikacja'
  },
  logging: {
    forgotPassword: 'Nie pamiętasz hasła?',
    logging: 'Logowanie',
    login: 'Zaloguj',
    registrationEndYouCanLogIn: 'Rejestracja zakończona pomyślnie.<br>Możesz się zalogować.',
    yourAccountActiveNow: 'Twoje konto jest już aktywne.<br>Możesz się zalogować.',
    yourPasswordChangeLogIn: 'Hasło do Twojego konta zostało zmienione.<br>Możesz się zalogować.'
  },
  message: {
    messageForCounter: '1 wiadomość | {n} wiadomości',
    noMessage: 'Brak wiadomości w wątku',
    read: 'Przeczytana',
    topic: {
      archiveTopicConfirmBtnTxt: 'Tak, archiwizuj',
      archiveTopicConfirmTitle: 'Czy na pewno chcesz zarchiwizować wątek?',
      archiveTopicErrorTxt: 'Archiwizacja wątku nie powiodła się. Spróbuj ponownie.',
      archiveTopicSuccessTitle: 'Wątek zarchiwizowany',
      archiveTopicSuccessTxt: 'Wiadomości w wątku zostały zarchiwizowane'
    }
  },
  messageForm: {
    addAttachment: 'Dodaj załącznik',
    attachedFiles: 'Załączone pliki',
    backToMessagesList: 'Wróć do listy wiadomości',
    deleteFile: 'Usuń plik',
    descriptionFile: 'Opis pliku',
    downloadFile: 'Pobierz plik',
    fileName: 'Nazwa pliku',
    messageWasSendInThread: 'Wiadomość został wysłana w wątku',
    modifyFile: 'Modyfikuj plik',
    myMessage: 'Moja wiadomość',
    noAssignedExpert: 'Brak przypisanego eksperta',
    numberOfCall: 'Numer rozmowy',
    offerPreview: 'Podgląd oferty',
    sendMessageError: 'Wysłanie wiadomości nie powiodło się. Spróbuj ponownie.',
    uploadFile: 'Prześlij plik',
    writeTheMessage: 'Napisz wiadomość'
  },
  messagesList: {
    afterLastDateMessage: 'Po dacie ostatniej wiadomości',
    archivedSelectedThreads: 'Wybrane wątki zostały zarchiwizowane',
    archivedThreads: 'Zarchiwizowano wątki',
    archivedThreadsError: 'Archiwizacja wątków nie powiodła się. Spróbuj ponownie.',
    archiveSelectThreads: 'Archiwizuj zaznaczone wątki',
    areYouSureArchivedSelectedThreads: 'Czy na pewno chcesz zarchiwizować wybrane wątki?',
    chooseCustomer: 'Wybierz klienta',
    chooseExpert: 'Wybierz eksperta',
    chooseOffer: 'Wybierz ofertę',
    directMessage: 'Wiadomość bezpośrednia',
    lastMessage: 'Ostatnia wiadomość',
    messageText: 'Tekst wiadomości',
    numberOfOffer: 'Oferta nr',
    originMessage: 'Pochodzenie wiadomości',
    thisOfferHasBeenRemoved: 'Ta oferta została usunięta'
  },
  monthsName: {
    april: 'kwiecień',
    aprilShort: 'kwi',
    august: 'sierpień',
    augustShort: 'sie',
    december: 'grudzień',
    decemberShort: 'gru',
    february: 'luty',
    februaryShort: 'lut',
    january: 'styczeń',
    januaryShort: 'sty',
    july: 'lipiec',
    julyShort: 'lip',
    june: 'czerwiec',
    juneShort: 'cze',
    march: 'marzec',
    marchShort: 'mar',
    may: 'maj',
    mayShort: 'maj',
    november: 'listopad',
    novemberShort: 'lis',
    october: 'październik',
    octoberShort: 'paź',
    september: 'wrzesień',
    septemberShort: 'wrz'
  },
  notesList: {
    addNotes: 'Dodaj notatkę',
    areYouSureDeleteSelectNote: 'Czy na pewno chcesz usunąć tę notatkę?',
    contentOfNote: 'Treść notatki',
    createDate: 'Data utworzenia',
    deleteNote: 'Usunięto notatkę',
    deleteNoteError: 'Usuwanie notatki nie powiodło się. Spróbuj ponownie.',
    deleteSelectNote: 'Wybrana notatka została usunięta',
    editNotes: 'Edycja notatki',
    lastModifyDate: 'Data ostatniej modyfikacji',
    modifyNoteError: 'Modyfikacja notatki nie powiodła się. Spróbuj ponownie.',
    newNotes: 'Nowa notatka',
    note: 'Notatka',
    noteForClient: 'Notatka dla klienta',
    noteSaved: 'Zapisano notatkę',
    selectedNoteWasRecorded: 'Wybrana notatka została zapisana'
  },
  opinion: {
    newOpinions: 'Najnowsze opinie',
    opinionByCustomer: 'Opinia dodana przez klienta',
    opinionForCounter: '1 opinia | {n} opinie | {n} opinii',
    opinionViolates: 'Jeśli jakaś opinia narusza Twój wizerunek lub nie zgadzasz się z jej treścią, skontaktuj się z nami niezwłocznie.',
    userImgThumbnail: 'Miniaturka obrazka użytkownika',
    yourOpinion: 'Twoje opinie'
  },
  pageLinks: {
    collaboration: 'Współpraca',
    compareCreditOffers: 'Porównaj oferty kredytów',
    contact: 'Kontakt',
    findTheBestExpert: 'Znajdź najlepszego eksperta',
    howThisWorks: 'Jak to działa',
    tutorials: 'Poradniki'
  },
  pageNotFound: {
    backToDashboard: 'Wróć do pulpitu',
    pageNotFound: 'Strony nie znaleziono.'
  },
  pagination: {
    advisors: 'ekspertów',
    articles: 'artykułów',
    buttonNext: 'Następna',
    buttonPrev: 'Poprzednia',
    customers: 'klientów',
    elements: 'elementów',
    inquiries: 'ofert',
    messages: 'wiadomości',
    outOf: 'z'
  },
  promotions: {
    amIWinning: 'Czy wygrywam',
    amount: 'Kwota',
    beginPromotionAuction: 'Rozpocznij licytację promocji',
    bidOnPromotion: 'Licytuj promocję',
    bidPromotion: 'Licytuj promocję',
    costOfPromotion: 'Koszt promocji',
    endsAt: 'Promocja zajęta do',
    highestBid: 'Najwyższa oferta',
    name: 'Nazwa',
    outbidPromotion: 'Przebij',
    pay: 'Opłać',
    paymentInformation: 'Informacje dotyczące płatności',
    placeABid: 'Złóż ofertę',
    placeBidErrorText: 'Składanie oferty w aukcji nie powiodło się. Spróbuj ponownie.',
    placeBidSuccessText: 'Twoja oferta w aukcji wybranej promocji została złożona.',
    placeBidSuccessTitle: 'Wystawienie oferty w aukcji',
    proceedToPayment: 'Przejdź do płatności',
    profilePlacement: 'Umiejscowienie profilu',
    promotions: 'Promocje',
    promotionTooltipInfo: 'Jeśli chcesz, aby Twój profil był częściej odwiedzany, zarezerwuj sobie miejsce promocyjne. Rezerwacja miejsca promocyjnego odbywa się w trybie licytacji. Ustal jaką kwotę możesz zapłacić za promocję swojego profilu. Jeśli w ciągu 24h nikt nie przebije Twojej oferty, Twój profil pojawi się w wybranym slocie. ',
    seeWhereYourProfileWillAppear: 'ZOBACZ GDZIE POJAWI SIĘ TWÓJ PROFIL.',
    status: {
      auction: 'Trwa licytacja',
      free: 'Wolny',
      occupied: 'Zajęty'
    }
  },
  register: {
    acceptTermsTxt: '<span>Akceptuję <a title="Regulamin" href="{regulationsUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">regulamin</a> oraz <a title="Polityka prywatności" href="{privacyPolictUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light"> politykę prywatności</a>.</span>',
    accountActivated: 'Aktywacja konta',
    contactAdviserAgreementTxt: 'Chcę otrzymywać mailowo informacje o ofertach, promocjach, usługach lub produktach finansowych bezpośrednio od ekspertów, których wizytówki dostępne są w serwisie ',
    contactFinhubAgreementTxt: 'Chcę otrzymywać mailowo informacje związane z możliwościami, jakie oferuje serwis ',
    dataProcessingAgreementTxt: '<span>Dane osobowe podane w formularzu przetwarzane są przez FINHUB Sp. z o.o. w celu świadczenia usług drogą elektroniczną zgodnie z <a title="Regulamin" href="{regulationsUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">regulaminem</a>, w celach archiwalnych oraz w celach odpowiadających treści zaznaczonych dodatkowo zgód.</span><br><span>Jeżeli zaznaczasz zgodę na otrzymywanie informacji bezpośrednio od ekspertów, działa ona globalnie, co oznacza, że każdy z ekspertów współpracujących z FINHUB może wysyłać do Ciebie wiadomości.</span><br><span>Szczegóły: <a title="Polityka prywatności" href="{privacyPolicyUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">polityka prywatności</a>.<span>',
    register: 'Zarejestruj się',
    registration: 'Rejestracja',
    registrationError: 'Błąd rejestracji. Spróbuj ponownie.',
    registrationExpert: 'Rejestracja Eksperta'
  },
  registerMailSent: {
    sendMessage: 'Wysłano wiadomość',
    sendMessageToEmail: 'Na podany adres e-mail została wysłana wiadomość zawierająca instrukcje dotyczące dokończenia rejestracji konta.'
  },
  resetPassword: {
    linkPasswordIncorrect: 'Wygenerowany link resetowania hasła jest niepoprawny.',
    resetPass: 'Resetowanie hasła',
    yourEmail: 'Twój adres e-mail',
    yourNewPassword: 'Twoje nowe hasło',
    yourPassword: 'Twoje hasło'
  },
  settlements: {
    allPricesAreNet: 'Wszystkie podane ceny są cenami netto.',
    amount: 'Kwota',
    changeYourPackage: 'Zmień swój pakiet',
    currentSubscription: 'Aktualny abonament',
    date: 'Data',
    download: 'Pobierz',
    expiresInDays: 'wygasa za {daysAmount} dni',
    expiresOn: 'Wygasa',
    extendThisPackageBy: 'Przedłuż ten pakiet o {timeTxt}',
    extendYourPackageBy: 'Przedłuż swój pakiet o {timeTxt}',
    grossPrice: 'Cena brutton',
    inactiveAccount: 'Twoje konto jest nieaktywne',
    invoice: 'Faktura',
    packageChange: 'Zmiana pakietu',
    packages: 'Pakiety',
    paymentHistory: 'Historia płatności',
    percentOff: '{percentAmount}% taniej',
    plnPerMonth: 'PLN / mc',
    probationaryPeriod: {
      probationaryPeriodMessage: 'Trwa okres próbny. Do końca okresu próbnego zostało',
      probationaryPeriodTime: 'dni'
    },
    purchaseBasicConfirmText: 'Czy potwierdzasz zmianę planu na {packageName}?<br>Jest to plan nieodpłatny, oferuje najmniej funkcji.',
    purchaseBasicPackageErrorText: 'Zmiana pakietu zakończona niepowodzeniem.<br>Spróbuj ponownie.',
    purchasePlanErrorText: 'Generowanie linku do płatności nie powiodło się.',
    purchasePlanSuccessText: 'Po kliknięciu "OK" nastąpi przekierowanie na stronę płatności.',
    purchasePlanSuccessTitle: 'Przejście do płatności',
    sectionAvailableForActiveUsers: 'Ta sekcja jest dostępna tylko dla użytkowników z aktywnym kontem.',
    selectPlan: 'Wybierz jeden z naszych planów.',
    subscriptionWalidIndefinitely: 'Pakiet jest ważny bezterminowo',
    type: 'Typ',
    yourCurrentPackage: 'Twój obecny pakiet',
    yourCurrentPackageIs: 'Twój obecny pakiet to {packageName}',
    yourPlan: 'Twój plan'
  },
  statuses: {
    accepted: 'Zaakceptowany',
    rejected: 'Odrzucony',
    toAccept: 'Czeka na akceptację'
  },
  time: {
    hoursShort: '{n} godz.',
    hoursShortAgo: '{n} godz. temu',
    minutesShort: '{n} min.',
    minutesShortAgo: '{n} min. temu',
    now: 'teraz',
    timeElapsedDay: '1 dzień | {n} dni',
    timeElapsedDayAgo: '1 dzień temu | {n} dni temu',
    timeElapsedMonth: '1 miesiąc | {n} miesiące | {n} miesięcy',
    timeElapsedMonthAgo: '1 miesiąc temu | {n} miesiące temu | {n} miesięcy temu',
    timeElapsedYear: '1 rok | {n} lata | {n} lat',
    timeElapsedYearAgo: '1 rok temu | {n} lata temu | {n} lat temu',
    today: 'Dzisiaj'
  },
  ui: {
    action: 'Akcje',
    add: 'Dodaj',
    added: 'Dodano',
    archive: 'Archiwizuj',
    assessment: 'Ocena',
    backToGeneralPage: 'Wróć na stronę główną',
    backToLoginPage: 'Wróć na stronę logowania',
    bank: 'Bank',
    calendar: 'Kalendarz',
    cancel: 'Anuluj',
    chooseBank: 'Wybierz bank',
    chooseCurrency: 'Wybierz walutę',
    chooseDate: 'Wybierz datę',
    chooseIndustry: 'Wybierz branżę',
    chooseYourSourceOfIncome: 'Wybierz źródło dochodu',
    close: 'Zamknij',
    comments: 'Komentarze',
    content: 'Treść',
    dataLoadError: {
      dataErrorMess: 'Wczytywanie danych nie powiodło się.',
      forTryAgain: 'aby spróbować ponownie.',
      resetPageButton: 'Odśwież stronę'
    },
    edit: 'Edytuj',
    errorOccurred: 'Wystąpił błąd',
    errorOccurredTryAgain: 'Wystąpił błąd. Proszę spróbować ponownie.',
    featured: 'Wyróżnione',
    form: 'Formularz',
    from: 'od',
    goToLoginPage: 'Idź na stronę logowania',
    invite: 'Zaproś',
    loadingDataInProgress: 'Trwa ładowanie danych',
    logout: 'Wyloguj',
    massCommunication: 'Masowa komunikacja',
    massCommunicationTitleMobile: 'Komunikacja',
    menu: 'Menu',
    messages: 'Wiadomości',
    myArticles: 'Moje artykuły',
    needsInteraction: 'wymagającą interakcji | wymagające interakcji | wymagających interakcji',
    next: 'Dalej',
    nip: 'NIP',
    no: 'Nie',
    none: 'Brak',
    noResultsForGivenPhrase: 'Brak wyników dla podanej frazy',
    notes: 'Notatki',
    notNow: 'Nie&nbsp;teraz',
    nr: 'nr',
    offers: 'Oferty',
    open: 'Otwórz',
    or: 'lub',
    pulpit: 'Pulpit',
    recentActivity: 'Ostatnia aktywność',
    refresh: 'Odśwież',
    remove: 'Usuń',
    save: 'Zapisz',
    saveChange: 'Zapisz zmiany',
    savedChanges: 'Zapisano zmiany',
    saveSetting: 'Zapisz ustawienia',
    search: 'Szukaj',
    seeAll: 'Zobacz wszystkie',
    send: 'Wyślij',
    sendAssessment: 'Wyślij ocenę',
    settings: 'Ustawienia',
    settlements: 'Rozliczenia',
    source: 'Źródło',
    thisOperationCannotUndone: 'Tej operacji nie można cofnąć',
    tin: 'TIN',
    title: 'Tytuł',
    to: 'do',
    tryAgain: 'Spróbuj ponownie',
    unread: 'nieodczytaną | nieodczytane | nieodczytanych',
    variant: 'Wariant',
    website: 'Strona internetowa',
    years: 'lat',
    yes: 'Tak',
    yesChange: 'Tak, zmień',
    yesIAgree: 'Tak, zgadzam się',
    yesInvite: 'Tak, zaproś',
    yesRemove: 'Tak, usuń',
    yesSend: 'Tak, wyślij',
    youHave: 'Masz'
  },
  user: {
    additionalSpecializations: 'Dodatkowe specjalizacje',
    address: 'Adres',
    association: 'Zrzeszenie',
    changePassword: 'Zmień hasło',
    choose: 'Wybierz',
    city: 'Miejscowość',
    county: 'Hrabstwo',
    currentPackageDoesNotIncludeAccessToSection: 'Twój aktualny pakiet nie obejmuje dostępu do tej sekcji.',
    distance: 'Odległość',
    emailAddress: 'Adres e-mail',
    firstName: 'Imię',
    fullName: 'Imię i nazwisko',
    functionUnavailableInCurrentPackage: 'Funkcja niedostępna w aktualnym pakiecie',
    lastName: 'Nazwisko',
    myAccount: 'Moje konto',
    taxIdentificationNumberGB: 'Tax Identification Number',
    other: 'Inne',
    otherAssociation: 'Inne zrzeszenie',
    password: 'Hasło',
    phone: 'Telefon',
    phoneNumber: 'Nr telefonu',
    postalCode: 'Kod pocztowy',
    province: 'Województwo',
    region: 'Region',
    repeatPassword: 'Powtórz hasło',
    savePassword: 'Zapisz hasło',
    selectAssociation: 'Wybierz zrzeszenie',
    selectCounty: 'Wybierz hrabstwo',
    selectOrder: 'Wybierz kolejność',
    selectProvince: 'Wybierz województwo',
    selectRegion: 'Wybierz region',
    selectSpecialization: 'Wybierz specjalizację',
    selectSpecializations: 'Wybierz specjalizacje',
    selectStatus: 'Wybierz status',
    specialization: 'Specjalizacja',
    status: 'Status',
    taxIdentificationNumber: 'Numer Identyfikacji Podatkowej (NIP)',
    userAvatar: 'Avatar użytkownika'
  },
  UserSettingsPasswordChange: {
    areYouSureToChangePassword: 'Czy na pewno chcesz zmienić swoje hasło?',
    newPassword: 'Nowe hasło',
    passwordChange: 'Zmiana hasła',
    passwordChangeError: 'Zmiana hasła nie powiodła się. Spróbuj ponownie.',
    passwordHasBeenChange: 'Hasło do Twojego konta zostało zmienione',
    passwordSave: 'Zapisano hasło'
  },
  validation: {
    date: 'Podanie daty jest wymagane',
    dateRange: 'Podanie zakresu dat jest wymagane',
    email: 'To pole musi zawierać poprawny adres e-mail',
    isChecked: 'To pole musi być zaznaczone aby kontynuować',
    maxCharacters: 'To pole może zawierać maksymalnie jeden znak | To pole może zawierać maksymalnie {n} znaki | To pole może zawierać maksymalnie {n} znaków',
    maxValue: 'Wartość nie może być większa niż {n}',
    minCharacters: 'To pole musi zawierać co najmniej jeden znak | To pole musi zawierać co najmniej {n} znaki | To pole musi zawierać co najmniej {n} znaków',
    minValue: 'Wartość nie może być mniejsza niż {n}',
    tin: 'TIN składa się z 2 liter, 6 cyfr i końcowej litery.',
    onlyNumbers: 'To pole musi zawierać liczbę',
    passwordsDontMatch: 'Hasła nie są identyczne',
    phone: 'To pole może zaczynać się znakiem "+" oraz zawierać cyfry i spacje',
    required: 'To pole jest wymagane',
    url: 'To pole musi zawierać poprawny adres URL',
    zipCode: 'To pole musi mieć format \"00-000\"',
    zipCodeGB: 'To pole musi zawierać prawidłowy kod pocztowy Wielkiej Brytanii'
  }
};
